import type { User } from '../api/types'

/** Сотрудник закреплён за объектом либо имеет права планирования и работает на любом объекте. */
export function worksOnObject(person: Pick<User, 'roles' | 'objects'>, objectId: string): boolean {
  if (!objectId) return true
  if (person.roles.some((role) => role !== 'ROLE_EXECUTOR')) return true
  return (person.objects ?? []).some((object) => object.id === objectId)
}

/**
 * Варианты для выбора исполнителя. При известном объекте исполнители этого объекта идут первой группой,
 * остальные сотрудники — второй: назначить можно любого, но пул свободных заданий видят только закреплённые.
 */
export function AssigneeOptions({ people, objectId }: { people: User[]; objectId?: string }) {
  if (!objectId) return <>{people.map((person) => <option key={person.id} value={person.id}>{person.fullName}</option>)}</>
  const onObject = people.filter((person) => worksOnObject(person, objectId))
  const others = people.filter((person) => !worksOnObject(person, objectId))
  if (others.length === 0) return <>{onObject.map((person) => <option key={person.id} value={person.id}>{person.fullName}</option>)}</>
  return (
    <>
      {onObject.length > 0 && <optgroup label="Исполнители объекта">{onObject.map((person) => <option key={person.id} value={person.id}>{person.fullName}</option>)}</optgroup>}
      <optgroup label="Другие сотрудники (не закреплены за объектом)">{others.map((person) => <option key={person.id} value={person.id}>{person.fullName}</option>)}</optgroup>
    </>
  )
}
